import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    typography: {
        marginBottom: theme.spacing(2),
    },
}));